import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import AppMenu from "../../menu";
import TablesData from "../globalTable";
import TableItem from "../globalTable/tableItem";
import { SearchOnly } from "../globalTable/searchandfilter";
import HorizontalTabs from "../../tabs/horizontalTabs";
import ActionModal from "../modals";
import ActionModalContent from "../modals/modalContent";
import { fetchPendingEnrollees, getEnrollees } from "../../../store/enrollee";
import { useDispatch, useSelector } from "react-redux";
import { getFormatedDate } from "../../../utils/constants";
import Loader from "../../common/Loader";
import { acceptRequest } from "../../../store/enrollee";
import notification from "../../common/Alert";

const tabLabels = ["Principal Directory", "Dependent Directory"];

export default function PendingEnrolees() {
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [content, setContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [selected, setSelected] = useState([]);
  let [pageNumber, setPageNumber] = useState(1);
  let [pageLists, setPageLists] = useState(10);
  const { activetab } = useParams();

  const tabNameToIndex = {
    0: "principal-directory",
    1: "dependent-directory",
  };

  const indexToTabName = {
    "principal-directory": 0,
    "dependent-directory": 1,
  };

  const [tabIndex, setTabIndex] = useState(indexToTabName[activetab]);
  const onChangeTabIndex = (e, newValue) => {
    history.push(`/hmo/dashboard/enrollees/${tabNameToIndex[newValue]}`);
    setTabIndex(newValue);
  };

  const dispatch = useDispatch();
  const enrolleesData = useSelector(getEnrollees);

  useEffect(() => {
    const fetchEnrollees = async () => {
      await dispatch(fetchPendingEnrollees(pageLists, pageNumber));
    };
    fetchEnrollees();
  }, [dispatch, pageNumber, pageLists]);

  const incrementPageNumber = async () => {
    setPageNumber((pageNumber += 1));
    await dispatch(fetchPendingEnrollees(pageLists, pageNumber));
  };

  const decrementPageNumber = async () => {
    setPageNumber((pageNumber -= 1));
    await dispatch(fetchPendingEnrollees(pageLists, pageNumber));
  };

  const handleSelectNumber = ({ target }) => {
    if (target.value === "30") {
      setPageLists(30);
    } else if (target.value === "20") {
      setPageLists(20);
    } else {
      setPageLists(10);
    }
  };

  const accept_request = async (id, value) => {
    setModal(false);
    const acceptEnrollee = await dispatch(
      acceptRequest(id, { enrollee_id: value }, "enrollees")
    );
    notification.notication("success", acceptEnrollee.payload.message, "", {
      position: "top-right",
    });
    await dispatch(fetchPendingEnrollees(10, 1));
  };

  const handleCloseModal = () => {
    setModal(false);
  };

  const handleOpenConfirmModal = (enrolleeName, id) => {
    setModal(true);
    setContent(
      <ActionModalContent
        approveTextTop={
          <p>
            Please enter an Enrollee ID to accept <b>{enrolleeName}</b> as an
            Enrollee.
          </p>
        }
        enroleeIdLabel
        formSection
        onApprove={(value) => accept_request(id, value)}
        onApproveSection
        onDecline={() => setModal(false)}
      />
    );
    setModalTitle("Confirm Enrollee");
  };

  const handleChange = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleSelectAllClick = () => {
    const newSelecteds = enrolleesData.pendingList.map((n) => n.id);
    setSelected(newSelecteds);
    return;
  };

  const handleSearchAndFilter = enrolleesData.pendingList.filter((searched) => {
    if (search === " ") {
      return searched;
    } else if (
      searched.first_name
        .toLowerCase()
        .includes(search && search.toLowerCase()) ||
      searched.last_name
        .toLowerCase()
        .includes(search && search.toLowerCase()) ||
      searched.phone_number.includes(search && search.toLowerCase())
    ) {
      return searched;
    } else {
      return null;
    }
  });
  return (
    <>
      <div
        style={{
          display: "flex",
          marginBottom: "2rem",
          justifyContent: "space-between",
        }}>
        <SearchOnly handleSearch={handleChange} searchWord={search} />
        <HorizontalTabs
          tabData={tabLabels}
          tabIndex={tabIndex}
          onTabChange={onChangeTabIndex}
        />
        {/* <FilterOnly /> */}
      </div>
      <Loader visible={enrolleesData.loading} />
      <TableItem
        userType="Enrollee"
        modal={
          <ActionModal
            modalTitle={modalTitle}
            content={content}
            open={modal}
            close={handleCloseModal}
          />
        }
        checkBoxes
        tabHeadLabel={[
          "Enrollee",
          "Email Address",
          "Phone Number",
          "Date Created",
        ]}
        action
        tableSize
        tabToolBar
        tabHeadCheck
        numSelectedItem={selected.length}
        rowCount={enrolleesData.pendingList.length}
        numSelected={selected.length}
        onSelectAllClick={handleSelectAllClick}
        currentPage={enrolleesData.currentPage}
        toPage={enrolleesData.toPage}
        totalPage={enrolleesData.total}
        handleIncrement={() => incrementPageNumber()}
        handleDecrement={() => decrementPageNumber()}
        disabledIncrement={pageNumber >= enrolleesData.lastPage}
        disabledDecrement={pageNumber <= 1}
        handleSelectPageNumber={handleSelectNumber}
        pageSelectValue={pageLists}
        tabBodyData={handleSearchAndFilter.map((item, i) => {
          const isItemSelected = isSelected(item.id);
          const labelId = `enhanced-table-checkbox-${i}`;
          return (
            <TablesData
              labelId={labelId}
              handleItemClick={(event) => handleClick(event, item.id)}
              aria-checked={isItemSelected}
              isItemSelected={isItemSelected}
              key={i}
              checkBoxes
              image
              imageUrl={item?.enrolee_photo}
              imgInitials={
                item?.first_name.slice(0, 1) + item?.last_name.slice(0, 1)
              }
              enroleeName={item.first_name + " " + item.last_name}
              enroleeId={item.enrollee_id}
              listItem={[
                item.email,
                item.phone_number,
                getFormatedDate(item.created_at, "YYYY/MMM/DD"),
              ]}
              action={
                <AppMenu
                  menu_name_or_icon={<MoreHorizIcon />}
                  item_names={[
                    {
                      "View More": () =>
                        history.push(
                          `/hmo/dashboard/enrollee/details/accept/${item.id}`
                        ),
                    },
                    {
                      Approve: () =>
                        handleOpenConfirmModal(
                          item.first_name + " " + item.last_name,
                          item.id
                        ),
                    },
                  ]}
                />
              }
            />
          );
        })}
        tablePagination
      />
    </>
  );
}
